import React from 'react';
import { Card, Container, Row, Col } from 'shared-portal-component';

import AdministratorsHeader from '@/components/organism/Administrators/AdministratorsHeader/AdministratorsHeader';
import AdministratorsTable from '@/components/organism/Administrators/AdministratorsTable/AdministratorsTable';
import { useAdministrators } from '@/hooks/pages/useAdministrators';
import ConfirmModalContainer from '@/components/common/Confirm/ConfirmModalContainer';

const Administrators: React.FC = () => {
  const {
    rows,
    loading,
    search,
    setSearch,
    handleOpenCreate,
    handleEdit,
    handleToggleActive,
    handleForceLogout,
    handleForceLoginReset,
    handleDelete,
  } = useAdministrators();

  return (
    <Container fluid>
      <Row spacing="none">
        <Col>
          <Card>
            <AdministratorsHeader
              onCreate={handleOpenCreate}
              searchValue={search}
              onSearchChange={setSearch}
            />
            <AdministratorsTable
              rows={rows}
              onEdit={handleEdit}
              onToggleActive={handleToggleActive}
              onForceLogout={handleForceLogout}
              onForceLoginReset={handleForceLoginReset}
              onDelete={handleDelete}
            />
            {loading && <div className="px-4 py-2 text-sm">Loading admins…</div>}
          </Card>
        </Col>
      </Row>
      <ConfirmModalContainer />
    </Container>
  );
};

export default Administrators;
